// extracted by mini-css-extract-plugin
var _1 = "ZRwc4kjJkKJ2VjXAjk6r";
export { _1 as "downloadsList" }
